import React from 'react';
import { getFileContentUrl } from 'helpers/file/getFileContentUrl';
import './style.scss';

interface ConsultantContactCardProps {
  consultant: GQL.IConsultant;
}

const ConsultantContactCard = ({ consultant }: ConsultantContactCardProps) => {
  return (
    <div className="consultantContactCard">
      {consultant?.file_avatar?.filename && (
        <img src={getFileContentUrl(consultant?.file_avatar)} alt={`${consultant?.jmeno} ${consultant?.prijmeni}`} />
      )}
      <p>
        {consultant?.jmeno} {consultant?.prijmeni}
        <br />
        {consultant?.mobil}
        <br />
        {consultant?.email}
      </p>
    </div>
  );
};

export default ConsultantContactCard;
